// Canonical comment deep-link fragment
//
// Record collaboration renders each comment as `id="comment-<id>"`. These
// routes may preserve that one fragment because it changes only the scroll
// target inside an otherwise audited record render. Keep the grammar closed:
// arbitrary fragments, separators, query-looking payloads, and an empty id
// must still take the route-recovery path rather than widening a record claim.
// Comment ids produced by the application are ASCII opaque identifiers (for
// example `cmt-<uuid>` and `wi-note-<id>`), so this accepts their stable token
// alphabet without admitting another URL shape.

const COMMENT_ANCHOR_HASH = /^#comment-[A-Za-z0-9][A-Za-z0-9._:-]*$/;

export function isCanonicalCommentAnchorHash(hash: unknown): hash is string {
  return typeof hash === 'string' && COMMENT_ANCHOR_HASH.test(hash);
}
